import { getAgentioScript } from '@farmersdog/pixels';
import { AGENTIO_PIXEL_ID } from './settings';
import { Script } from 'src/components/Script';

const { sdkLoader } = getAgentioScript(AGENTIO_PIXEL_ID);

export const AgentioScript = () => {
  return <Script type="text/javascript">{sdkLoader}</Script>;
};
